<template>
	<div ref="scrollContainer" id="page-panel" class="box grow scrollable" >
    <div class="customer-top-nav no-print">
			<span class="title" >Profil d'entreprise</span>
			<div class="controls">
				<el-button @click="close();">{{$t('buttons.close')}}</el-button>
			</div>
		</div>
    <el-tabs type="border-card" >
        <el-tab-pane label="Entreprise">
          <div class="controls">
            <el-button type="primary" @click="saveGeneralInfo">{{ $t('common.save') }}</el-button>
          </div>
          <h3>{{$t('business.GeneralInformation')}}</h3>
          
          <el-form ref="formGeneralInfo" :model="model.business" label-width="120px" label-position="top" :rules="rules">
            label: 'Épuré',
              <el-input v-model="model.business.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('business.StreetAddress')" prop="address.street">
              <el-input v-model="model.business.address.street"></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.City')" prop="address.city">
                  <el-input v-model="model.business.address.city"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.Province')" prop="address.state">
                  <el-input v-model="model.business.address.state"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.Country')" prop="address.country">
                  <el-input v-model="model.business.address.country"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.PostalCode')" prop="address.postalCode">
                  <el-input v-model="model.business.address.postalCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.ContactName')" prop="contactName">
                  <el-input v-model="model.business.contactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.ContactEmail')" prop="contactEmail">
                  <el-input v-model="model.business.contactEmail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.BusinessPhone')">
                  <el-input v-model="model.business.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="Mobile Phone">
                  <el-input v-model="model.business.mobile"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider />
            <h3>{{ $t('business.preferences') }}</h3>
            <el-form-item :label="$t('business.InvoicePrefix')" prop="invoice.prefix">
              <el-input v-model="model.business.invoice.prefix" />
            </el-form-item>
            <el-form-item :label="$t('business.invoicePaymentInstruction')" v-if="model.INVOICE_PERSONNALIZED === true">
              <el-tabs type="border-card">
                <el-tab-pane :label="$t('common.french')">
                  <quill-editor v-model="model.business.invoice.paymentInstruction.fr" style="border:1px solid #EBEEF5;min-height:200px;"
                    ref="noteEditor"
                    :options="editorOptions">
                  </quill-editor>
                </el-tab-pane>
                <el-tab-pane :label="$t('common.english')">
                  <quill-editor v-model="model.business.invoice.paymentInstruction.en" style="border:1px solid #EBEEF5;min-height:200px;"
                    ref="noteEditor"
                    :options="editorOptions">
                  </quill-editor>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item :label="$t('business.DefaultCurrency')" prop="currency">
              <el-select v-model="model.business.currency" placeholder="Select" value-key="id">
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :label="currency.code"
                  :value="currency">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item :label="$t('business.EndFiscalDate')" prop="fiscalDate">
              <el-date-picker
               v-model="model.business.fiscalDate"
               format="dd MMMM"
               type="date"
               :placeholder="$t('common.selectDateInstruction')">
             </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('business.repCanModifyTitle')" prop="repCanModify">
              <el-checkbox v-model="model.business.repCanModify">{{ $t('business.canRepModifyInstruction') }}</el-checkbox>
            </el-form-item>
            <el-divider />
            <h3>Personnalisation PDF</h3>
            <el-form-item label="Template de fiche technique par défaut">
              <el-select v-model="model.business.reportCustomization.technicalSheetTemplate" style="width: 100%;" value-key="value">
                <el-option
                  v-for="template in technicalSheetTemplates"
                  :key="template.value"
                  :label="template.label"
                  :value="template.value">
                  <span>
                    <i :class="template.icon" style="margin-right: 8px;"></i>
                    <strong>{{ template.label }}</strong>
                    <span style="color: #909399; margin-left: 8px;">{{ template.description }}</span>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="8">
                <el-form-item label="Couleur dominante">
                  <el-color-picker v-model="model.business.reportCustomization.dominantColor"></el-color-picker>
                  <el-input class="mt-10" v-model="model.business.reportCustomization.dominantColor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item label="Couleur secondaire">
                  <el-color-picker v-model="model.business.reportCustomization.secondaryColor"></el-color-picker>
                  <el-input class="mt-10" v-model="model.business.reportCustomization.secondaryColor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item label="Couleur non dominante">
                  <el-color-picker v-model="model.business.reportCustomization.nonDominantColor"></el-color-picker>
                  <el-input class="mt-10" v-model="model.business.reportCustomization.nonDominantColor"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('business.Notifications')" disabled>
        </el-tab-pane>
        <el-tab-pane :label="$t('business.SAQAgency')" v-if="model.SAQ_PROCESS_MODULE_ACTIVATED === true">
          <div class="controls">
            <el-button type="primary" @click="saveAgencyInfo">{{ $t('common.save') }}</el-button>
          </div>
          <h3>{{$t('business.SAQAgencyInformation')}}</h3>
          <el-form ref="formAgencyInfo" :model="model.defaultAgency" label-width="120px" label-position="top" :rules="rules">
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.agency.name')" prop="model.defaultAgency.name">
                  <el-input v-model="model.defaultAgency.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.agency.agentNumber')" prop="model.defaultAgency.agentNumber">
                  <el-input v-model="model.defaultAgency.agentNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.agency.saqUserCode')" prop="model.defaultAgency.saqUserCode">
                  <el-input v-model="model.defaultAgency.saqUserCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.agency.saqPassword')" prop="model.defaultAgency.saqPassword">
                  <el-input v-model="model.defaultAgency.saqPassword"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item :label="$t('business.ContactName')" prop="model.defaultAgency.contactName">
                  <el-input v-model="model.defaultAgency.contactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item :label="$t('business.ContactEmail')" prop="model.defaultAgency.contactEmail">
                  <el-input v-model="model.defaultAgency.contactEmail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
       
      </el-tabs>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausCompanyAPI from '@/services/API/portaus-company.js'
import dayjs from 'dayjs'
import customParseFormat from "dayjs/plugin/customParseFormat";
export default {
  name : "business",
  data() {
    return {
      editorOptions: {
          theme: 'bubble',
          placeholder:"",
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike', 'link']
            ]
          }
        },
      model: {
        id: null,
        business: {
          name : null,
          contactName: null,
          repCanModify: null,
          contactEmail: null,
          fiscalEndDay: null,
          fiscalEndMonth: '',
          currency: null,
          fiscalDate: null,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            postalCode: null,
          },
          phone: null,
          mobile: null,
          invoice: {
            prefix: null,
            paymentInstruction: {
              fr: null,
              en: null,
            },
          },
          reportCustomization: {
            dominantColor: '#0f766e',
            secondaryColor: '#e8edf0',
            nonDominantColor: '#d9f2ef',
            technicalSheetTemplate: 'classic',
          },
          INVOICE_PERSONNALIZED: null,
          SAQ_PROCESS_MODULE_ACTIVATED: null,
        },
        defaultAgency: {
            id: null,
            name: null,
            agentNumber: null,
            saqUserCode: null,
            saqPassword: null,
            contactName: null,
            contactEmail: null,
          },
       
      },
      technicalSheetTemplates: [
        {
          value: 'classic',
          label: 'Classique',
          description: '2 colonnes image + details',
          icon: 'mdi mdi-view-column',
        },
        {
          value: 'split',
          label: 'Moderne',
          description: 'bloc infos separé et mise en page alternative',
          icon: 'mdi mdi-view-dashboard-outline',
        },
        {
          value: 'stacked',
          label: 'Empile',
          description: 'vin puis image puis description, fiche a droite',
          icon: 'mdi mdi-view-sequential',
        },
      ],
      rules : {
        name : [
          { required: true, message: 'Veuillez saisir un nom de compagnie', trigger: 'blur' }
        ],
        'address.street' : [
          { required: true, message: `Veuillez renseigner l'adresse de la companie`, trigger: 'blur' }
        ],
        'address.state' : [
          { required: true, message: `Veuillez renseigner la province`, trigger: 'blur' }
        ],
        'address.city' : [
          { required: true, message: `Veuillez renseigner la ville`, trigger: 'blur' }
        ],
        'address.country' : [
          { required: true, message: `Veuillez renseigner le pays`, trigger: 'blur' }
        ],
        'address.postalCode' : [
          { required: true, message: `Veuillez renseigner le code postal`, trigger: 'blur' }
        ],
        contactName : [
          { required: true, message: `Veuillez renseigner le contact principal de la compagnie`, trigger: 'blur' }
        ],
        contactEmail : [
          { required: true, message: `Veuillez renseigner le courriel du contact principal`, trigger: 'blur' }
        ],
        'invoice.prefix': [
        { required: true, message: `Veuillez saisir un préfixe`, trigger: 'blur' }
        ],
        currency : [
          { required: true, message: `Veuillez sélectionner une devise par défaut`, trigger: 'blur' }
        ],
        fiscalDate : [
          { required: true, message: `Veuillez renseigner la date de la fin de votre année fiscale`, trigger: 'blur' }
        ],
        agentNumber : [
          { required: true, message: `Veuillez renseigner le numéro d'agent`, trigger: 'blur' }
        ],
      }
    };
  },components: {

  },
	methods: {
    close () {
			this.$router.go(-1);
		},
    initAgenciesModel (agencies) {
      //TODO Il peut y avoir plusieurs définition d'agence... 
      // une par défaut et les autres ssi multipleAgence est actif
      const defaultAgencyInfo = _.find(agencies, agency => agency.default === true);

      if (defaultAgencyInfo != null) {
        this.model.defaultAgency.id = defaultAgencyInfo.id;
        this.model.defaultAgency.name = defaultAgencyInfo.name;
        this.model.defaultAgency.agentNumber = defaultAgencyInfo.saqAgentNumber;
        this.model.defaultAgency.saqUserCode = defaultAgencyInfo.saqUserCode;
        // this.defaultAgency.saqPassword = defaultAgencyInfo.
        this.model.defaultAgency.contactName = defaultAgencyInfo.contactName;
        this.model.defaultAgency.contactEmail = defaultAgencyInfo.email
      }
    },
    initModel (portausCompany) {
      dayjs.extend(customParseFormat);
      this.model.id = _.get(portausCompany, 'id');
      this.model.business.name = _.get(portausCompany, 'name');
      this.model.business.contactName = _.get(portausCompany, 'contactName');
      this.model.business.repCanModify = _.get(portausCompany, 'repCanModify');
      this.model.business.contactEmail = _.get(portausCompany, 'contactEmail');
      this.model.business.fiscalEndMonth = _.get(portausCompany, 'fiscalEndMonth');
      this.model.business.fiscalEndDay = _.get(portausCompany, 'fiscalEndDay');
      this.model.business.currency = _.get(portausCompany, 'currency');
      if (this.model.business.fiscalEndDay != null && this.model.business.fiscalEndDay != null) {
        this.model.business.fiscalDate = dayjs(`${this.model.business.fiscalEndMonth}-${this.model.business.fiscalEndDay}`, 'M-D').format('M-D');
      }
      this.model.business.address.street = _.get(portausCompany, 'address.street');
      this.model.business.address.city = _.get(portausCompany, 'address.city');
      this.model.business.address.state = _.get(portausCompany, 'address.state');
      this.model.business.address.postalCode = _.get(portausCompany, 'address.postalCode');
      this.model.business.address.country = _.get(portausCompany, 'address.country');
      this.model.business.phone = _.get(portausCompany, 'phone');
      this.model.business.mobile = _.get(portausCompany, 'mobile');
      this.model.business.invoice.prefix = _.get(portausCompany, 'invoice.prefix');
      this.model.business.invoice.paymentInstruction = _.get(portausCompany, 'invoice.paymentInstruction');
      if (this.model.business.invoice.paymentInstruction == null) {
        this.model.business.invoice.paymentInstruction = {};
        this.model.business.invoice.paymentInstruction.fr = null;
        this.model.business.invoice.paymentInstruction.en = null;
      }
      const reportCustomization = _.get(portausCompany, 'reportCustomization', {});
      this.model.business.reportCustomization = {
        ...reportCustomization,
        dominantColor: _.get(reportCustomization, 'dominantColor', '#0f766e'),
        secondaryColor: _.get(reportCustomization, 'secondaryColor', '#e8edf0'),
        nonDominantColor: _.get(reportCustomization, 'nonDominantColor', '#d9f2ef'),
        technicalSheetTemplate: _.get(reportCustomization, 'technicalSheetTemplate', 'classic'),
      };
      if (!_.includes(['classic', 'split', 'stacked'], this.model.business.reportCustomization.technicalSheetTemplate)) {
        this.model.business.reportCustomization.technicalSheetTemplate = 'classic';
      }
      this.model.SAQ_PROCESS_MODULE_ACTIVATED = _.get(portausCompany, 'saqProcessModuleInd');
      this.model.INVOICE_PERSONNALIZED= _.get(portausCompany, 'invoice.personnalizedInvoice');
    },
    saveAgencyInfo () {
      const agencyInfoPutData = {
        id: this.model.defaultAgency.id,
        name : this.model.defaultAgency.name,
        contactName: this.model.defaultAgency.contactName,
        email: this.model.defaultAgency.contactEmail,
        saqUserCode: this.model.defaultAgency.saqUserCode,
        saqAgentNumber: this.model.defaultAgency.agentNumber,
        saqPassword: _.get(this.model, 'defaultAgency.saqPassword'),
        default: true,
      }
      return PortausCompanyAPI.updateAgencyInformation(agencyInfoPutData.id, agencyInfoPutData)
        .then(() => {
          console.log('test')
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$i18n.t('common.errors.generic'));
        })
     
    },
    saveGeneralInfo () {
      return this.$refs['formGeneralInfo'].validate()
        .then(() => {
          const fiscalEndMonth = dayjs(this.model.business.fiscalDate).format('M');
          const fiscalEndDay = dayjs(this.model.business.fiscalDate).format('D');
          const putData = {
            name: this.model.business.name,
            contactName: this.model.business.contactName,
            contactEmail: this.model.business.contactEmail,
            fiscalEndDay,
            fiscalEndMonth,
            phone: this.model.business.phone,
            mobile: this.model.business.mobile,
            repCanModify: this.model.business.repCanModify,
            currency: {
              id: _.get(this.model, 'business.currency.id'),
            },
            address: this.model.business.address,
            invoice: {
              prefix: this.model.business.invoice.prefix,
              paymentInstruction: this.model.business.invoice.paymentInstruction,
            },
            reportCustomization: this.model.business.reportCustomization,
          }

          return PortausCompanyAPI.updatePortausCompany(this.model.id, putData)
            .then(() => {
              this.fetchPortausCompany();
              this.$message.success('Sauvegarde effectuée avec succès!');
            }).catch((err) => {
              console.log(err);
              this.$message.error(this.$i18n.t('common.errors.generic'));
            })

        }).catch((err) => {
          this.$message.warning('Le formulaire comporte certaines erreurs ou informations manquantes!');
        })
    },
    fetchPortausCompany () {
      this.loading = true;
      const portausCompanyId = this.$cookies.get('portaus-context-company');
      PortausCompanyAPI.getPortausCompany(portausCompanyId)
        .then((portausCompany) => {
          this.loading = true;
          this.initModel(_.head(portausCompany));
        }).catch((err) => {
          console.log(err);
          this.$message.error(this.$i18n.t('common.errors.generic'));
        });
    },
    fetchAgenciesInformation () {
      return PortausCompanyAPI.fetchAgencyInformation()
        .then((agencies) => {
          this.initAgenciesModel(agencies);
        })
    },
    ...mapActions('controlData', ['fetchCurrencies']),
	},
	computed: {
    fiscalEndDay () {
      if (this.fiscalDate != null) {
        return dayjs(this.model.business.fiscalDate).format('D');
      }
      return null;
    },
    fiscalEndMonth () {
      if (this.fiscalDate != null) {
        return dayjs(this.model.business.fiscalDate).format('M');
      }
      return null;
    },
    ...mapState('controlData', ['currencies']),
	},
	created(){
    this.fetchCurrencies();
    this.fetchPortausCompany();
    this.fetchAgenciesInformation();
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
</style>
